<template>
  <div class="mCooperation">
    <div class="sutpContentPanel flex-center-start">
      <!-- 左边 -->
      <div class="sutpLeft sutpIem">
        <div
          class="sutpLeftItem"
          v-for="(item, index) in sutpLeftItem"
          :key="index"
        >
          <div class="sutpLeftItemTiltle">{{ item.title }}</div>
          <div
            class="sutpLeftSubItem"
            v-for="(item1, index1) in item.sutpLeftSubItem"
            :key="index1"
          >
            <div class="sutpLeftSubItemTitle">{{ item1.subTitle }}</div>
            <div
              class="sutpLeftSubItemMobilePanel flex-center-start"
              v-for="(item2, index2) in item1.sutpLeftMobile"
              :key="index2"
            >
              <span class="sutpLeftSubItemName">{{ item2.name }}</span>
              <span class="sutpLeftSubItemMobile">{{ item2.mobile }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="sutpCenter">
        <div
          class="sutpCenterItem sutpIem"
          v-for="(item, index) in sutpCenterItem"
          :key="index"
        >
          <div class="sutpCenterItemTitle">{{ item.title }}</div>
          <div
            class="sutpCenterItemWechatPanel"
            v-for="(item1, index1) in item.wechatItem"
            :key="index1"
          >
            <span class="sutpCenterItemName">{{ item1.name }}</span>
            <span class="sutpCenterItemWechat">{{ item1.wechat }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边 -->
    <div class="theActivityAgendaContentRight">
      <div
        class="
          theActivityAgendaContentRightItem
          theActivityAgendaContentItem
          flex-center-end
        "
        v-for="(item, index) in sutpRightItem"
        :key="index"
      >
        <div class="sutpRightItemText">
          <div class="sutpRightItemTextTitle">{{ item.title }}</div>
          <div class="sutpRightItemTextSubtitle">{{ item.subTitle }}</div>
        </div>
        <div class="sutpRightItemQrcode theActivityAgendaContentQrcode flex">
          <img :src="item.img" alt />
        </div>
      </div>
      <div
        class="
          theActivityAgendaContentRightItem
          theActivityAgendaContentTopItem
          flex-center-center
        "
      >
        <img src="@/images/com/logo.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sutpLeftItem: [
        {
          title: "赞助、商务合作请联系",
          sutpLeftSubItem: [
            {
              subTitle: "游戏、电竞板块",
              sutpLeftMobile: [
                { name: "文静", mobile: "Wechat: mutou_kiki" },
                // { name: "西瓜", mobile: "18659030320" },
                // { name: "林晗", mobile: "18823803517" },
              ],
            },
            {
              subTitle: "XR、AI板块",
              sutpLeftMobile: [
               // { name: "西瓜", mobile: "18659030320" },
                { name: "六六", mobile: "Wechat: lu0130611" },
              ],
            },
          ],
        },
      ],
      sutpCenterItem: [
        {
          title: "项目合作请联系",
          wechatItem: [
            { name: "Cos", wechat: "  Wechat: xxhh304 " },
            // { name: "晋羽", wechat: "Wechat: silver9393" },
          ],
        },
       
      ],
      sutpRightItem: [
        // {
        //   title: "第六届金陀螺参评报名投票",
        //   subTitle: "码上参评投票",
        //   img: require("@/images/com/cptp.png"),
        // },
        {
          title: "FBEC2025大会报名通道",
          subTitle: "扫码报名参会",
          img: require("@/images/com/bmch.png"),
        },
        {
          title: "关注FBEC微信公众号",
          subTitle: "扫码了解更多",
          img: require("@/images/com/fbec_gzh.png"),
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.mCooperation {
  .sutpContentPanel {
    height: 4rem;
  }
  .sutpIem {
    border-radius: 0.04rem;
    background: rgba(98, 0, 21, 0.36);
    border: 0.01rem solid #dd1920;
  }
  .sutpLeftItemTiltle,
  .sutpCenterItemTitle {
    font-size: 0.26rem;
    font-weight: 500;
    color: #ffffff;
  }
  .sutpLeftSubItemName,
  .sutpCenterItemName {
    padding-right: 0.16rem;
  }
  .sutpCenterItem,
  .sutpRightItem {
    // height: 3.45rem;
    height: 99.8%;
  }
  .sutpCenterItem:not(:first-child),
  .sutpRightItem:not(:first-child) {
    margin-top: 0.1rem;
  }
  .sutpLeftSubItemMobilePanel,
  .sutpCenterItemWechatPanel {
    font-size: 0.2rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 0.1rem;
  }
  // 左
  .sutpLeft {
    width: 3.04rem;
    height: 100%;
    text-align: left;
  }
  .sutpLeftItem {
    padding: 0.4rem 0.16rem 0.28rem 0.16rem;
  }

  .sutpLeftSubItem {
    margin-top: 0.34rem;
  }
  .sutpLeftSubItemTitle {
    font-size: 0.16rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
    padding-bottom: 0.24rem;
    text-align: left;
  }
  .sutpCenterItemWechatPanel:not(:first-child) {
    margin-top: 0.1rem;
  }
  // 中
  .sutpCenter {
    margin-left: 0.1rem;
    width: 3.56rem;
    text-align: left;
    height: 100%;
  }
  .sutpCenterItem {
    padding: 0 0 0 0.16rem;
  }
  .sutpCenterItemTitle {
    padding: 0.41rem 0 0.24rem 0;
  }
}
.sutpRightItemTextSubtitle {
  font-size: 0.16rem;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 0.07rem;
  text-align: end;
}
</style>


// WEBPACK FOOTER //
// src/components/m/mCooperation.vue